import React from "react";
import "./contact.scss";
import Button from "../../buttons/Button";
import { motion } from "framer-motion";
const Contact = () => {
  function InfoCard({ icon, text }) {
    return (
      <div className="info-card">
        <span>{icon}</span>
        <p>{text}</p>
      </div>
    );
  }
  function InfoCardSocial() {
    return (
      <div className="info-card">
        <span>
          <i class="fa-sharp fa-solid fa-share-nodes"></i>
        </span>
        <div className="social-link">
          <span>
            <a href="#">
              <i class="fa-brands fa-facebook-f"></i>
            </a>
          </span>
          <span>
            <a href="#">
              <i class="fa-brands fa-instagram"></i>
            </a>
          </span>
          <span>
            <a href="#">
              <i class="fa-brands fa-linkedin"></i>
            </a>
          </span>
          <span>
            <a href="#">
              <i class="fa-brands fa-github"></i>
            </a>
          </span>
        </div>
      </div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ type: "tween", duration: 0.5 }}
      className="contact"
    >
      <h2>Get in touch</h2>
      <div className="wrapper">
        <div className="left">
          <form className="form">
            <input type="text" placeholder="Name" />
            <input type="email" placeholder="Email" />
            <textarea
              placeholder="Message"
              id=""
              cols="30"
              rows="10"
            ></textarea>
          </form>
          <Button name={"Submit"} />
        </div>
        <div className="right">
          <InfoCard
            icon={<i class="fa-solid fa-location-dot"></i>}
            text={"Brook 103, 90021 New York, USA"}
          />
          <InfoCard
            icon={<i class="fa-solid fa-phone"></i>}
            text={"+77 033 442 55 57"}
          />
          <InfoCardSocial />
        </div>
      </div>
    </motion.div>
  );
};

export default Contact;
